import { Form } from '@block/plug';
import { ICode } from '../position';

// 职位投递状态
export interface IPositionDeliveryStatus {
  isApplied: boolean; // 是否投递过
  isOnline: boolean; // 是否还未过期
  isVolunteerFull?: boolean;
  haveIntentionJob?: boolean;
  canApply: boolean; // 是否可以投递
  applyJobStep: {
    code: string;
    name: string;
  } | null;
  jobName: string | null;
}

// 历史投递信息
export interface IDeliveryInfo {
  jobId: string;
  interestBG: ICode;
  workCityList: ICode[];
  acceptWorkCityAdjust: boolean;
  acceptJobAdjust: boolean;
  intentionJob: {
    code: string;
    name: string;
    jobUnionId?: string;
    order: number;
  }[];
  recommendationNum: string;
  source: string;
}

/**
 * @description: 绑定的伯乐信息
 */
export interface IBindBoleInfo {
  boleName: string;
  recommendationNum?: string; // 内推码
  type?: number; // 1:内推码 2:外推码
  source?: string;
}

/**
 * @description: 伯乐信息,根据token && staffSsoId 获取的
 */
export interface IBoleInfo {
  boleMis: string;
  boleName: string;
  staffSsoId?: string;
  recommendationNum?: string; // 内推码
  phone?: string;
  type?: number; // 1:内推码 2:外推码
  source?: string;
}

// 根据Bg获取职位工作城市
export interface IWorkCity {
  cityList: ICode[];
}

/**
 * @description: 志愿单表单中的职位信息接口
 */
export interface IVolunteerJobItem {
  jobUnionId?: string;
  name?: string;
  jobId: string;
  jobName: string;
}

// 志愿单职位列表
export interface IVolunteerJobList {
  list: {
    jobUnionId: string;
    name: string;
    jobType: string;
    jobId: string;
    jobName: string;
  }[];
}

/**
 * @description: 志愿单表单接口
 */
export interface IVolunteerItem {
  customId?: number;
  volunteerStatus: number;
  volunteerItemId: number;
  jobId: string;
  jobName: string;
  isLikeAllBG: boolean;
  isLikeAllCity: boolean;
  interestBG: ICode;
  volunteerItemStatus: EnumVolunteerItemStatus;
  officialJobPublishStatus: EnumOfficialJobPublishStatus;
  aspirationDirectionList: ICode[];
  workCityList: any;
}

/**
 * @description: 志愿单流程状态
 */
export enum EnumVolunteerItemStatus {
  /**
   * @description: 未开始
   */
  notStart = 0,
  /**
   * @description: 进行中
   */
  inProcess = 1,
  /**
   * @description: 已结束
   */
  end = 2,
}

/**
 * @description: 志愿类型
 */
export enum EnumVolunteerType {
  notHaveIntentionJob = 0, // 无明确意向
  volunteer1 = 1, // 志愿1
  volunteer2 = 2, // 志愿2
  volunteer3 = 3, // 志愿3
  volunteer4 = 4, // 调剂职位
}

/**
 * @description: 志愿单单个志愿投递记录
 */
export interface IVolunteerItemSchedule {
  deliverTime: string;
  deliverType: string;
  bgName: string;
  volunteerType: EnumVolunteerType;
  volunteerItemStepName: string;
  volunteerCategory: string;
  jobId: string;
  jobType: string;
  jobName: string;
  jobShareType: string;
  workCity: string[];
  aspirationDirectionNameList: string[];
  volunteerItemId: number;
  volunteerItemStatus: EnumVolunteerItemStatus;
  officialJobPublishStatus: EnumOfficialJobPublishStatus;
}

/**
 * @description: 老投递记录
 */
export interface IGeneralRecord {
  jobId: string;
  applyJobId: string;
  jobType: string;
  jobShareType: string;
  jobName: string;
  workCity: string[];
  applyStatus: string;
  deliverTime: number;
  deliverType: string;
  logList?: {
    title: string;
    content: string;
    time: string;
  }[];
}

export interface IApplyProcess {
  existStep: boolean; // 当前节点是否已完成或进行中
  stepCode: string;
  stepInfo: Object | null;
  stepName: string;
}

/**
 * @description: 新校招志愿单记录
 */
export interface IVolunteerRecord {
  volunteerId: string; // 志愿单单个志愿ID
  projectId: string; // 项目ID
  projectName: string; // 项目名称
  volunteerItemSchedule: IVolunteerItemSchedule[];
  applyProcess: IApplyProcess; // 流程阶段
  externalShowProgress: boolean | null; // 项目状态
}

// 投递记录列表
export interface IDeliveryItem {
  volunteerRecord: IVolunteerRecord;
  generalRecord: IGeneralRecord;
  deliverTime: string;
  deliverTimeNum?: number;
}

export type PlugForm<T = any> = {
  getFieldsValue: () => T;
} & Form;

export interface ForwardRefInterface {
  getRecommendationNumInfo: () => {
    codeErr: boolean;
    recommendNum: string;
    recommendNumType: number | undefined;
  };
}

/**
 * @description: 职位发布状态
 */
export enum EnumOfficialJobPublishStatus {
  /**
   * @description: 1-进行中
   */
  inProcess = '1',
  /**
   * @description: 2-已下架（不可编辑）
   */
  removed = '2',
  /**
   * @description: 3-未在官网发布过（不可编辑&不可跳转）
   */
  notPublish = '3',
}

/**
 * @description: 毕业时间不符合错误信息
 */

export interface IGraduationErrorInfo {
  jobUnionId: string;
  errorCode: string;
  freshGraduateDateStart: string;
  freshGraduateDateEnd: string;
  internshipGraduateStart: string;
  internshipGraduateEnd: string;
  jobType: string;
  jobName: string;
}

// 简历意向方向信息
export interface IAspirationDirectionInfo {
  code: string;
  name: string;
  children: null;
  sort: null;
  subCode: null;
  mapping: null;
  outerCode: null;
  bgNode: boolean;
}
